module.exports = __webpack_public_path__ + "static/media/L Nadine H.6ae79873.png";